export default __webpack_public_path__ + "static/media/home-icon.750f19e9.svg";